import {usePanorama} from '@wix/yoshi-flow-editor'
import {createCheckoutVisibility} from './checkout-visibility'

export const createLogger = ({panoramaClient}: CreateLoggerParams) => {
  const checkoutVisibility = createCheckoutVisibility({panoramaClient})

  return {
    startInteraction: (interaction: Interaction) => {
      panoramaClient?.transaction?.(interaction).start()
    },
    finishInteraction: (interaction: Interaction) => {
      panoramaClient?.transaction?.(interaction).finish()
    },
    startCheckoutAttempt: checkoutVisibility.startAttempt,
    recoverCheckoutAttempt: checkoutVisibility.recoverAttempt,
    restoreCheckoutAttempt: checkoutVisibility.restoreAttempt,
    reportCheckoutStage: checkoutVisibility.reportStage,
    reportCheckoutStageOnce: checkoutVisibility.reportStageOnce,
    finishCheckoutAttempt: checkoutVisibility.finishAttempt,
    getCheckoutAttemptId: checkoutVisibility.getAttemptId,
    getCheckoutRouteContext: checkoutVisibility.getRouteContext,
    setCheckoutPaymentPath: checkoutVisibility.setPaymentPath,
    getCheckoutPaymentPath: checkoutVisibility.getPaymentPath,
  }
}

interface CreateLoggerParams {
  panoramaClient: ReturnType<typeof usePanorama>
}

export enum Interaction {
  LoadingTickets = 'loading-tickets',
  PaymentWidgetLoad = 'PAYMENT_WIDGET_LOAD',
}

export type Logger = ReturnType<typeof createLogger>
